<template>
  <div class="account_index">
    <div class="account_index_nav">
      <navbar
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.7rem'"
        :titlecolor="'#333'"
        @goback="goBack(false)"
      />
    </div>
    <div class="box">
      <p class="title">对公账户</p>
      <van-row class="bank_info">
        <span class="label">已绑定</span>
        <van-col span="24" class="name">
          {{ withdraw_info.account_name }}
          <!-- <span>18989898989</span> -->
        </van-col>
        <van-col span="24" class="address">
          {{ withdraw_info.account_bank }} |
          {{ withdraw_info.account_branch_bank }}
        </van-col>
        <van-col span="24" class="account_num">
          <span v-for="(item, index) in account_number" :key="index">{{
            item
          }}</span>
        </van-col>
      </van-row>
      <!-- <van-row class="operation">
        <van-col span="12">
          <p class="left" @click="delect">
            <img src="@/assets/purchaseSupplier/withdraw/delect.png" />删除
          </p>
        </van-col>
        <van-col span="12">
          <p @click="change">
            <img src="@/assets/purchaseSupplier/withdraw/change.png" />修改
          </p>
        </van-col>
      </van-row> -->
    </div>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      withdraw_info: {},
      account_number: [],
    };
  },
  created() {
    this.withdraw_info = JSON.parse(localStorage.getItem("withdraw_info"));
    let len = Math.ceil(this.withdraw_info.account_number.length / 4);
    for (var i = 0; i < len; i++) {
      if (i + 1 == len) {
        this.account_number[i] = this.withdraw_info.account_number.slice(
          i * 4,
          this.withdraw_info.account_number.length
        );
      } else {
        this.account_number[i] = this.withdraw_info.account_number.slice(
          i * 4,
          (i + 1) * 4
        );
      }
    }
  },
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // delect() {
    //   this.$dialog
    //     .confirm({
    //       title: "温馨提示",
    //       message: "确定要删除当前绑定的对公账户吗？",
    //       confirmButtonText: "确定",
    //       confirmButtonColor: "#F9591B",
    //       cancelButtonText: "取消",
    //       cancelButtonColor: "#333",
    //     })
    //     .then(() => {
    //       // on confirm
    //       this.$api
    //         .post("/investment/member/agent/order/after/add", {
    //           ordersn: item.ordersn,
    //         })
    //         .then((res) => {
    //           this.$toast("退款申请已提交成功");
    //           var length = this.page;
    //           this.list = [];
    //           this.page = 0;
    //           for (var j = 0; j < length; j++) {
    //             this.page = j + 1;
    //             this.getInfo();
    //           }
    //         })
    //         .catch((err) => {
    //           let keys = Object.keys(err);
    //           let key = keys[0];
    //           let message = err.message || err[key][0];
    //           //this.$toast(message);
    //           if (message.slice(0, 10) == "timeout of") {
    //             this.$toast("网络不给力，请稍候重试");
    //           } else {
    //             this.$toast(message);
    //           }
    //           return;
    //         });
    //     })
    //     .catch(() => {
    //       // on cancel
    //     });
    // },
    // change() {
    //   // this.$router.push("/purchaseSupplier/changeBind");
    // },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.account_index {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .account_index_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    z-index: 3;
  }

  .box {
    box-sizing: border-box;
    height: 100%;
    padding: 8.8rem 1.6rem 0;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .title {
      line-height: 6.8rem;
      columns: #333;
      font-size: 2rem;
      font-weight: 700;
    }

    .bank_info {
      height: 15.3rem;
      padding: 2.4rem 2.4rem 0;
      background: url(../../../assets/purchaseSupplier/withdraw/bankBg.png)
        no-repeat center center;
      background-size: 100% 100%;
      border-radius: 0.8rem;
      box-sizing: border-box;
      position: relative;
      color: #fff;

      .label {
        position: absolute;
        right: 2.4rem;
        top: 2.4rem;
        display: inline-block;
        width: 6rem;
        height: 2.8rem;
        line-height: 2.8rem;
        text-align: center;
        border-radius: 1.4rem;
        background: #348fff;
        font-size: 1.2rem;
      }

      .name {
        font-size: 1.6rem;
        line-height: 2.2rem;

        span {
          margin-left: 0.8rem;
        }
      }

      .address {
        color: rgba(255, 255, 255, 0.6);
        font-size: 1.2rem;
        margin: 0.8rem 0 3.6rem;
      }

      .account_num {
        font-size: 2.2rem;
        line-height: 3rem;

        span {
          margin-right: 0.8rem;
        }
      }
    }

    .operation {
      height: 2rem;
      line-height: 2rem;
      margin-top: 4.8rem;
      color: #666;
      font-size: 1.4rem;
      text-align: center;

      .left {
        border-right: solid 0.1rem #dddddd;
      }

      img {
        width: 1.6rem;
        margin-right: 0.8rem;
        vertical-align: middle;
      }
    }
  }
}
</style>
<style lang="less" scoped>
.van-dialog {
  border-radius: 2.5rem;
  height: 19.7rem;
  width: 29.6rem;

  .van-dialog__header {
    color: #333;
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 2.2rem;
    margin: 4rem 0 1.6rem;
    padding: 0;
  }

  .van-hairline--top::after {
    border: none;
  }

  .van-dialog__footer {
    display: block;
    border: none;
    box-shadow: none;
    padding: 0 1.6rem;

    .van-dialog__cancel {
      color: #333;
      width: 11.9rem;
      height: 3.6rem;
      font-size: 1.4rem;
      border: solid 1px #eee;
      border-radius: 1.8rem;
    }

    .van-dialog__confirm {
      float: right;
      color: #fff;
      width: 11.9rem;
      height: 3.6rem;
      font-size: 1.4rem;
      border-radius: 1.8rem;
      background: -webkit-linear-gradient(to right, #fc740c, #f41a3c);
      /* Safari 5.1 - 6.0 */
      background: -o-linear-gradient(to right, #fc740c, #f41a3c);
      /* Opera 11.1 - 12.0 */
      background: -moz-linear-gradient(to right, #fc740c, #f41a3c);
      /* Firefox 3.6 - 15 */
      background: linear-gradient(to right, #fc740c, #f41a3c);
    }
  }

  .van-dialog__content {
    min-height: 6.3rem;
    .van-dialog__message {
      padding: 0 1rem !important;
      color: #333;
      font-weight: 700;
      font-size: 1.4rem;
      line-height: 2rem;
    }

    .van-dialog__message--has-title {
      padding: 0;
      color: #333;
    }
  }
}
</style>
